import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from '@/contexts/AuthContext';
import "@/App.css";
import Home from "@/pages/Home";
import BestOfThree from "@/pages/BestOfThree";
import HistoryNew from "@/pages/HistoryNew";
import HistorySimple from "@/pages/HistorySimple";
import HistoryComplete from "@/pages/HistoryComplete";
import MyContentAnalyses from "@/pages/MyContentAnalyses";
import AnalysisDetail from "@/pages/AnalysisDetail";
import Pricing from "@/pages/Pricing";
import APIDocs from "@/pages/APIDocs";
import Admin from "@/pages/Admin";
import AdminDashboard from "@/pages/AdminDashboard";
import SuperAdmin from "@/pages/SuperAdmin";
import SuperAdminNew from "@/pages/SuperAdminNew";
import AuthPage from "@/pages/AuthPage";
import Share from "@/pages/Share";
import ComparisonShare from "@/pages/ComparisonShare";
import Profile from "@/pages/Profile";
import OAuthCallback from "@/pages/OAuthCallback";
import Privacy from "@/pages/Privacy";
import Dashboard from "@/pages/Dashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/best-of-3" element={<BestOfThree />} />
            <Route path="/login" element={<AuthPage />} />
            <Route path="/oauth-callback" element={<OAuthCallback />} />
            <Route path="/history" element={<HistoryNew />} />
            <Route path="/history-simple" element={<HistorySimple />} />
            <Route path="/history-complete" element={<HistoryComplete />} />
            <Route path="/my-content-analyses" element={<MyContentAnalyses />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/analysis/:analysisId" element={<AnalysisDetail />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/payment-success" element={<Pricing />} />
            <Route path="/api-docs" element={<APIDocs />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/superadmin" element={<SuperAdminNew />} />
            <Route path="/superadmin-old" element={<SuperAdmin />} />
            <Route path="/share/:shareId" element={<Share />} />
            <Route path="/share/comparison/:id" element={<ComparisonShare />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;